import React, { useState, useEffect, useRef } from "react";
import { Modal, Form, Input, Button, Select, notification } from "antd";
import { BASE_URL, callApi } from "../../api/apiCaller";
import { GreenNotify, RedNotify } from "../../helper/helper";
import routes from "../../api/routes";
import configureAppStore from "../../redux/store";

const AddVideo = ({ visible, toggleModal, recordData }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [video, setVideo] = useState(null);
  const [videoUploading, setVideoUploading] = useState(false);
  const [yogas, setYogas] = useState([]);
  const [fileError, setFileError] = useState("");
  const [content, setContent] = useState("");
  const imageInputRef = useRef(null);
  const videoInputRef = useRef(null);

  const { Option } = Select;
  const dummyImage =
    "https://novathreadbucket.s3.amazonaws.com/nova-app-1685176470232-dummy.PNG";

  useEffect(() => {
    if (visible) {
      if (recordData) {
        form.setFieldsValue({
          title: recordData?.title,
          yogaId: recordData?.yogaId?._id,
          content: recordData?.content || "",
        });
        setImage(recordData?.image || dummyImage);
        setVideo(recordData?.url || null);
        setContent(recordData?.content || "");
      } else {
        form.resetFields();
        setImage(dummyImage);
        setVideo(null);
        setContent("");
      }
    }
  }, [visible, recordData, form]);

  useEffect(() => {
    if (visible) {
      callApi(
        "GET",
        `${routes.getYogas}`,
        null,
        setIsLoading,
        (res) => {
          if (res.status === 200) {
            setYogas(res?.data?.faceYogas);
          } else {
            RedNotify("Error Occurred. Please try again later.");
          }
        },
        (error) => {
          RedNotify(
            "An error occurred during the API call. Please try again later.",
            error
          );
        }
      );
    }
  }, [visible]);

  const pickFile = (isImage) => {
    if (isImage) {
      imageInputRef.current.click();
    } else {
      videoInputRef.current.click();
    }
  };
  const token = configureAppStore.getState().userDataSlice.token;

  const uploadFileOnS3 = async (file) => {
    const myHeaders = new Headers();
    const formData = new FormData();
    formData.append("file", file);
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", token);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };
    return await new Promise((resolve, reject) => {
      fetch(`${BASE_URL}/uploadFile`, requestOptions)
        .then((response) => response.json())
        .then((result) => resolve(result?.url))
        .catch((error) => reject(error));
    });
  };

  const handleFileChange = async (event, isImage) => {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      if (!isImage) setVideoUploading(true);
      try {
        const fileUrl = await uploadFileOnS3(fileList[0], isImage);
        if (isImage) {
          setImage(fileUrl);
        } else {
          setVideo(fileUrl);
          notification.success({
            message: "Video Uploaded",
            description: "Your video has been uploaded successfully.",
          });
        }
        setFileError("");
      } catch (error) {
        setFileError("An error occurred while uploading the file.");
      } finally {
        if (!isImage) setVideoUploading(false);
      }
    } else {
      setFileError("Please select a file.");
    }
  };

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);
        const requestBody = {
          ...values,
          url: video,
          image: image,
          content: content,
        };

        const getRes = (res) => {
          if (res.status === 200) {
            GreenNotify(
              recordData
                ? "Blog Updated Successfully"
                : "Blog Created Successfully"
            );
            toggleModal();
          } else {
            RedNotify("Error Occurred. Please try again later.");
          }
          setIsLoading(false);
        };

        const apiCall = recordData
          ? callApi(
              "PATCH",
              `${routes.updateBlog}/${recordData._id}`,
              requestBody,
              setIsLoading,
              getRes
            )
          : callApi(
              "POST",
              `${routes.createBlog}`,
              requestBody,
              setIsLoading,
              getRes
            );

        apiCall.catch((error) => {
          RedNotify(
            "An error occurred during the API call. Please try again later.",
            error
          );
        });
      })
      .catch((errorInfo) => {
        console.error("Validation Error:", errorInfo);
      });
  };

  return (
    <Modal
      title={recordData ? "Update Blog" : "Create Blog"}
      visible={visible}
      onCancel={toggleModal}
      footer={[
        <Button key="cancel" onClick={toggleModal}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={handleSave}>
          {recordData ? "Update" : "Save"}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="FaceYoga"
          name="yogaId"
          rules={[{ required: true, message: "Please select FaceYoga" }]}
        >
          <Select placeholder="Select FaceYoga">
            {yogas.map((yoga) => (
              <Option key={yoga._id} value={yoga._id}>
                {yoga.title}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: "Please enter the title" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Content"
          name="content"
          rules={[{ required: true, message: "Please enter the content" }]}
        >
          <Input.TextArea
            rows={4}
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
        </Form.Item>
        <div
          onClick={() => pickFile(true)}
          style={{ marginBottom: "2rem" }}
          className="add-product-modal-input-title"
        >
          <h2>Image</h2>
          <div className="add-product-modal-image">
            <img
              src={image || dummyImage}
              alt="image"
              style={{ width: "100px", height: "100px", margin: "0 5px" }}
            />
          </div>
          <input
            type="file"
            ref={imageInputRef}
            style={{ display: "none" }}
            onChange={(e) => handleFileChange(e, true)}
            required
          />
          {fileError && <p style={{ color: "red" }}>{fileError}</p>}
        </div>
      </Form>
    </Modal>
  );
};

export default AddVideo;
